(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cards-slider-slideshow]').forEach(function (slideshow) {
    var root = slideshow.closest('.cards-slider');
    var counter = root && root.querySelector('[data-cards-slider-counter]');
    if (!slideshow || !counter) return;

    function sync(index) {
      var total = parseInt(counter.getAttribute('data-total'), 10) || 1;
      counter.textContent = index + 1 + '/' + total;
    }

    slideshow.addEventListener('slideshow:select', function (e) {
      var idx = 0;
      if (e.detail && typeof e.detail.index === 'number') idx = e.detail.index;
      sync(idx);
    });
    sync(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"]) return;
  try {
    
    (function () {
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var mediaEls = [];
      var ticking = false;
      var maxShiftRatio = 0.08;

      function collect() {
        mediaEls = Array.prototype.slice.call(
          document.querySelectorAll('[data-collection-hero-parallax]')
        );
        update();
      }

      function update() {
        if (!mediaEls.length) return;

        if (reducedMotion.matches) {
          mediaEls.forEach(function (el) {
            el.style.removeProperty('--collection-hero-parallax-y');
          });
          return;
        }

        var viewH = window.innerHeight || 1;

        mediaEls.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > viewH) return;

          var progress = (rect.top + rect.height / 2 - viewH / 2) / viewH;
          if (progress > 1) progress = 1;
          if (progress < -1) progress = -1;

          var shift = -progress * rect.height * maxShiftRatio;
          el.style.setProperty('--collection-hero-parallax-y', shift.toFixed(2) + 'px');
        });
      }

      function onScroll() {
        if (!mediaEls.length || ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      }

      function init() {
        collect();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        if (reducedMotion.addEventListener) {
          reducedMotion.addEventListener('change', update);
        } else if (reducedMotion.addListener) {
          reducedMotion.addListener(update);
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }

      document.addEventListener('shopify:section:load', collect);
      document.addEventListener('shopify:section:unload', collect);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-story"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var resizeTimer = 0;

      /**
       * @param {ParentNode} [root]
       */
      function syncCollectionStoryReadMores(root) {
        var stories;
        if (root && root.classList && root.classList.contains('collection-story--clamp')) {
          stories = [root];
        } else {
          var scope = root || document;
          stories = scope.querySelectorAll('.collection-story--clamp');
        }

        stories.forEach(function (story) {
          var btn = story.querySelector('[data-collection-story-read-more]');
          if (!btn) return;

          if (story.classList.contains('collection-story--expanded')) {
            btn.hidden = false;
            return;
          }

          var bodyId = btn.getAttribute('aria-controls');
          var body = bodyId ? document.getElementById(bodyId) : null;
          if (!body) {
            btn.hidden = true;
            return;
          }

          btn.hidden = !(body.scrollHeight > body.clientHeight + 1);
        });
      }

      function scheduleSync() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          syncCollectionStoryReadMores();
        }, 100);
      }

      function setExpanded(story, btn, expanded) {
        story.classList.toggle('collection-story--expanded', expanded);
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var moreLabel = btn.getAttribute('data-read-more-label') || 'Read more';
        var lessLabel = btn.getAttribute('data-read-less-label') || 'Read less';
        btn.textContent = expanded ? lessLabel : moreLabel;
        if (!expanded) {
          syncCollectionStoryReadMores(story);
        } else {
          btn.hidden = false;
        }
      }

      document.addEventListener(
        'click',
        function (event) {
          var target = /** @type {HTMLElement | null} */ (event.target);
          var btn = target && target.closest ? target.closest('[data-collection-story-read-more]') : null;
          if (!btn) return;

          var story = btn.closest('.collection-story');
          if (!story) return;

          var expanded = story.classList.contains('collection-story--expanded');
          setExpanded(story, btn, !expanded);
        },
        { capture: false }
      );

      function init() {
        syncCollectionStoryReadMores();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () {
            syncCollectionStoryReadMores();
          });
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }

      window.addEventListener('resize', scheduleSync);
      document.addEventListener('shopify:section:load', function (event) {
        syncCollectionStoryReadMores(event.target);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var desktopQuery = window.matchMedia('(min-width: 750px)');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var queue = [];
      var pumping = false;

      function saveData() {
        var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!connection) return false;
        if (connection.saveData) return true;
        return connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g';
      }

      function breakpointOk(video) {
        var onDesktop = !!video.closest('.hero-slider__desktop');
        return onDesktop ? desktopQuery.matches : !desktopQuery.matches;
      }

      function inView(video) {
        var rect = video.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
      }

      function tryPlay(video) {
        video.muted = true;
        video.defaultMuted = true;
        var pending = video.play();
        if (pending && typeof pending.catch === 'function') pending.catch(function () {});
      }

      function dequeue(video) {
        queue = queue.filter(function (item) {
          return item !== video;
        });
      }

      function disarm(video) {
        dequeue(video);
        video.pause();
        video.classList.remove('is-ready');
        if (video.dataset.armed === 'true') {
          video.dataset.armed = 'false';
          video.removeAttribute('src');
          video.load();
        }
      }

      function whenPosterReady(video, callback) {
        var frame = video.closest('.hero-slider__slide-frame');
        var image = frame && frame.querySelector('.hero-slider-slide-inner__img');
        if (!image || image.complete) {
          callback();
          return;
        }
        image.addEventListener('load', callback, { once: true });
        image.addEventListener('error', callback, { once: true });
      }

      function pump() {
        if (pumping) return;
        var video = queue.shift();
        if (!video) return;
        pumping = true;
        arm(video, function () {
          pumping = false;
          pump();
        });
      }

      function enqueue(video) {
        if (!video || video.dataset.armed === 'true' || queue.indexOf(video) !== -1) return;
        if (!breakpointOk(video) || reduceMotion.matches || saveData()) return;
        queue.push(video);
        pump();
      }

      function arm(video, done) {
        var settled = false;
        function finish() {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          if (done) done();
        }
        var timer = window.setTimeout(finish, 8000);

        if (!breakpointOk(video) || reduceMotion.matches || saveData()) {
          finish();
          return;
        }
        if (video.dataset.armed === 'true') {
          if (video.classList.contains('is-ready')) tryPlay(video);
          finish();
          return;
        }
        var src = video.getAttribute('data-src');
        if (!src) {
          finish();
          return;
        }

        video.dataset.armed = 'true';
        whenPosterReady(video, function () {
          if (video.dataset.armed !== 'true' || !breakpointOk(video)) {
            finish();
            return;
          }
          function reveal() {
            if (!breakpointOk(video)) return;
            video.muted = true;
            video.defaultMuted = true;
            var pending = video.play();
            var show = function () {
              video.classList.add('is-ready');
              finish();
            };
            if (pending && typeof pending.then === 'function') {
              pending.then(show).catch(function () {
                video.classList.remove('is-ready');
                finish();
              });
            } else {
              show();
            }
          }
          video.addEventListener('error', function () {
            video.classList.remove('is-ready');
            finish();
          }, { once: true });
          if (video.readyState >= 3 && video.src) {
            reveal();
            return;
          }
          video.addEventListener('canplay', reveal, { once: true });
          video.preload = 'auto';
          video.src = src;
        });
      }

      function bind(section) {
        if (!section || section.dataset.heroVideoBound === 'true') return;
        var videos = section.querySelectorAll('.hero-banner-video');
        if (!videos.length) return;
        section.dataset.heroVideoBound = 'true';

        function watch(video) {
          if (inView(video)) enqueue(video);
          else if (video.dataset.armed === 'true') video.pause();
        }

        var observer = null;
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) enqueue(entry.target);
              else if (entry.target.dataset.armed === 'true') entry.target.pause();
            });
          }, { rootMargin: '160px 0px', threshold: 0.01 });
          videos.forEach(function (video) {
            observer.observe(video);
          });
        } else {
          videos.forEach(watch);
        }

        function onBreakpoint() {
          queue = queue.filter(function (video) {
            return !section.contains(video);
          });
          videos.forEach(disarm);
          videos.forEach(watch);
        }

        if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onBreakpoint);

        section._heroVideoCleanup = function () {
          if (observer) observer.disconnect();
          if (desktopQuery.removeEventListener) desktopQuery.removeEventListener('change', onBreakpoint);
          videos.forEach(disarm);
          section.dataset.heroVideoBound = 'false';
        };
      }

      function boot(root) {
        if (root && root.classList && root.classList.contains('hero-slider-section')) {
          bind(root);
          return;
        }
        var scope = root && root.querySelectorAll ? root : document;
        scope.querySelectorAll('.hero-slider-section').forEach(bind);
      }

      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
      else boot(document);

      document.addEventListener('shopify:section:load', function (event) {
        var section = event.target.querySelector('.hero-slider-section');
        if (!section && event.target.classList && event.target.classList.contains('hero-slider-section')) section = event.target;
        if (section) bind(section);
      });

      document.addEventListener('shopify:section:unload', function (event) {
        var section = event.target.querySelector('.hero-slider-section');
        if (!section && event.target.classList && event.target.classList.contains('hero-slider-section')) section = event.target;
        if (section && section._heroVideoCleanup) section._heroVideoCleanup();
      });

      document.addEventListener('visibilitychange', function () {
        document.querySelectorAll('.hero-banner-video.is-ready').forEach(function (video) {
          if (document.hidden) video.pause();
          else if (breakpointOk(video) && inView(video)) tryPlay(video);
        });
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (function () {
    function openSiteSearch(trigger) {
      trigger.blur();

      const modal = document.getElementById('search-modal');
      if (modal && typeof modal.showDialog === 'function') {
        modal.showDialog();
        return;
      }

      const headerSearch = document.querySelector('search-button button, .search-action button');
      if (headerSearch) {
        headerSearch.click();
        return;
      }

      const searchUrl = trigger.getAttribute('data-search-url');
      if (searchUrl) window.location.href = searchUrl;
    }

    function applyBlogSearch(root) {
      const input = root.querySelector('[data-blog-search]');
      if (!input) return;

      const query = input.value.trim().toLowerCase();
      const results = root.querySelector('[data-search-results]');
      const countEl = root.querySelector('[data-search-count]');
      const clearBtn = root.querySelector('[data-search-clear]');
      const noResults = root.querySelector('.blog-grid__no-results');
      const items = results ? results.querySelectorAll('[data-search-item]') : [];

      if (clearBtn) clearBtn.hidden = query.length === 0;

      if (!query) {
        root.classList.remove('is-searching');
        if (results) results.hidden = true;
        if (countEl) countEl.hidden = true;
        if (noResults) noResults.hidden = true;
        items.forEach((item) => {
          item.hidden = false;
        });
        return;
      }

      root.classList.add('is-searching');
      if (results) results.hidden = false;

      let visible = 0;
      items.forEach((item) => {
        const haystack = (item.getAttribute('data-search-text') || '').toLowerCase();
        const match = haystack.includes(query);
        item.hidden = !match;
        if (match) visible += 1;
      });

      if (countEl) {
        countEl.hidden = false;
        countEl.textContent = visible === 1 ? '1 Article' : visible + ' Articles';
      }

      if (noResults) {
        noResults.hidden = visible > 0;
        const template = noResults.getAttribute('data-message-template') || '';
        noResults.textContent = template.replace('[query]', input.value.trim());
      }

      requestAnimationFrame(() => updateSearchWrap(root));
    }

    function updateSearchWrap(root) {
      const tabs = root.querySelector('.blog-grid__filter-nav-wrap');
      const cluster = root.querySelector('.blog-grid__search-cluster');
      if (!tabs || !cluster) return;
      cluster.classList.remove('is-wrapped');
      const wrapped = cluster.offsetTop > tabs.offsetTop + 2;
      cluster.classList.toggle('is-wrapped', wrapped);
    }

    function closeSpaceDropdown(dropdown) {
      if (!dropdown) return;
      dropdown.classList.remove('is-open');
      const trigger = dropdown.querySelector('[data-space-trigger]');
      const panel = dropdown.querySelector('.blog-grid__space-panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    }

    function toggleSpaceDropdown(dropdown) {
      if (!dropdown) return;
      const isOpen = dropdown.classList.contains('is-open');
      document.querySelectorAll('[data-space-dropdown].is-open').forEach((openDropdown) => {
        if (openDropdown !== dropdown) closeSpaceDropdown(openDropdown);
      });
      if (isOpen) {
        closeSpaceDropdown(dropdown);
        return;
      }
      dropdown.classList.add('is-open');
      const trigger = dropdown.querySelector('[data-space-trigger]');
      const panel = dropdown.querySelector('.blog-grid__space-panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) panel.hidden = false;
    }

    function clearBlogSearch(root) {
      const input = root.querySelector('[data-blog-search]');
      if (!input || !input.value) return;
      input.value = '';
      applyBlogSearch(root);
    }

    function revealBlogCardImage(img, failed) {
      const media = img.closest('.blog-grid__card-media');
      if (media) media.classList.remove('is-loading');
      if (!failed) img.classList.add('is-loaded');
    }

    function initBlogCardImages(root) {
      const scope = root || document;
      scope.querySelectorAll('.blog-grid__card-media img').forEach((img) => {
        if (img.dataset.imageBound) return;
        img.dataset.imageBound = 'true';
        if (img.complete && img.naturalWidth > 0) {
          revealBlogCardImage(img);
          return;
        }
        img.addEventListener('load', () => revealBlogCardImage(img), { once: true });
        img.addEventListener('error', () => revealBlogCardImage(img, true), { once: true });
      });
    }

    function initPageSearch(root) {
      const scope = root || document;
      initBlogCardImages(scope);
      scope.querySelectorAll('[data-blog-search]').forEach((input) => {
        if (input.dataset.searchBound) return;
        input.dataset.searchBound = 'true';
        const grid = input.closest('.blog-grid');
        if (!grid) return;
        input.addEventListener('input', () => applyBlogSearch(grid));
      });

      scope.querySelectorAll('.blog-grid').forEach((grid) => {
        if (grid.dataset.wrapObserved) return;
        grid.dataset.wrapObserved = 'true';
        const toolbar = grid.querySelector('.blog-grid__tools');
        updateSearchWrap(grid);
        if (!toolbar || typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(() => updateSearchWrap(grid));
        observer.observe(toolbar);
      });
    }

    let blogFilterAbort = null;
    let blogFilterRequest = 0;
    let blogFilterUsed = false;

    function getBlogSectionId(grid) {
      const host = grid.closest('blog-grid');
      if (host && host.getAttribute('section-id')) return host.getAttribute('section-id');
      const section = grid.closest('[id^="shopify-section-"]');
      if (!section || !section.id) return '';
      return section.id.replace(/^shopify-section-/, '');
    }

    function getBlogClearUrl(grid, fallbackHref) {
      const fromGrid = grid && grid.getAttribute('data-blog-url');
      if (fromGrid) return fromGrid;
      const allOption = grid && grid.querySelector('.blog-grid__space-option--all');
      if (allOption && allOption.getAttribute('href')) return allOption.getAttribute('href');
      return fallbackHref;
    }

    function normalizeBlogPath(path) {
      if (!path) return '/';
      if (path.length > 1 && path.endsWith('/')) return path.slice(0, -1);
      return path;
    }

    function isCurrentBlogUrl(url) {
      const next = new URL(url, window.location.href);
      return (
        normalizeBlogPath(next.pathname) === normalizeBlogPath(window.location.pathname) &&
        next.search === window.location.search
      );
    }

    function isClearingBlogFilter(filterBtn, grid) {
      if (!filterBtn) return false;
      if (filterBtn.classList.contains('blog-grid__space-option--all')) return true;
      if (filterBtn.classList.contains('is-active')) return true;
      if (filterBtn.classList.contains('blog-grid__filter-btn--active')) return true;
      if (filterBtn.getAttribute('aria-current') === 'true') return true;
      if (filterBtn.getAttribute('aria-selected') === 'true') return true;
      const clearUrl = getBlogClearUrl(grid, '');
      if (clearUrl && isCurrentBlogUrl(filterBtn.href) === false) {
        try {
          return normalizeBlogPath(new URL(filterBtn.href, window.location.href).pathname) ===
            normalizeBlogPath(new URL(clearUrl, window.location.href).pathname);
        } catch (e) {
          return false;
        }
      }
      return false;
    }

    function resolveBlogFilterUrl(filterBtn, grid) {
      if (isClearingBlogFilter(filterBtn, grid)) {
        return getBlogClearUrl(grid, filterBtn.href);
      }
      return filterBtn.href;
    }

    function lockBlogScroll(y) {
      const root = document.documentElement;
      const previous = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      if (typeof window.scrollTo === 'function') {
        try {
          window.scrollTo({ top: y, left: 0, behavior: 'instant' });
        } catch (e) {
          window.scrollTo(0, y);
        }
      }
      root.style.scrollBehavior = previous;
    }

    function replaceBlogFilterChild(grid, newGrid, selector) {
      const current = grid.querySelector(selector);
      const next = newGrid.querySelector(selector);
      if (current && next) {
        current.replaceWith(next);
        return;
      }
      if (current && !next) current.remove();
      if (!current && next) {
        const main = grid.querySelector('[data-blog-grid-main]');
        if (main) main.after(next);
      }
    }

    function applyBlogFilterMarkup(grid, newGrid) {
      replaceBlogFilterChild(grid, newGrid, '.blog-grid__tools');
      replaceBlogFilterChild(grid, newGrid, '[data-search-results]');
      replaceBlogFilterChild(grid, newGrid, '[data-blog-grid-main]');
      replaceBlogFilterChild(grid, newGrid, 'blog-grid-load-more');
      delete grid.dataset.wrapObserved;
    }

    async function parseBlogGridFromResponse(response) {
      const text = await response.text();
      const trimmed = text.trim();
      let html = text;
      if (trimmed.startsWith('{')) {
        try {
          const data = JSON.parse(text);
          html = typeof data === 'string' ? data : Object.values(data).join('');
        } catch (e) {
          html = text;
        }
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return {
        grid: doc.querySelector('.blog-grid'),
        title: doc.querySelector('title') ? doc.querySelector('title').textContent : '',
      };
    }

    async function fetchBlogFilterGrid(url, sectionId, signal) {
      const pageUrl = new URL(url, window.location.href);
      const candidates = [];
      if (sectionId) {
        const sectionUrl = new URL(pageUrl);
        sectionUrl.searchParams.set('section_id', sectionId);
        candidates.push(sectionUrl.toString());
        const sectionsUrl = new URL(pageUrl);
        sectionsUrl.searchParams.set('sections', sectionId);
        candidates.push(sectionsUrl.toString());
      }
      candidates.push(pageUrl.toString());

      let lastError = null;
      for (const candidate of candidates) {
        const response = await fetch(candidate, {
          signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) {
          lastError = new Error('filter fetch failed');
          continue;
        }
        const parsed = await parseBlogGridFromResponse(response);
        if (parsed.grid) return parsed;
        lastError = new Error('filter markup missing');
      }
      throw lastError || new Error('filter markup missing');
    }

    function getBlogCardHrefs(root) {
      return new Set(
        Array.from(root.querySelectorAll('.blog-grid__card a[href]')).map((link) => link.getAttribute('href'))
      );
    }

    function blogGridHasNewCards(grid, existingHrefs) {
      const newMain = grid && grid.querySelector('[data-blog-grid-main]');
      if (!newMain) return false;
      return Array.from(newMain.querySelectorAll('.blog-grid__card a[href]')).some((link) => {
        const href = link.getAttribute('href');
        return href && !existingHrefs.has(href);
      });
    }

    async function fetchBlogLoadMoreGrid(url, sectionId, existingHrefs) {
      const pageUrl = new URL(url, window.location.href);
      const candidates = [];
      if (sectionId) {
        const sectionUrl = new URL(pageUrl);
        sectionUrl.searchParams.set('section_id', sectionId);
        candidates.push(sectionUrl.toString());
        const sectionsUrl = new URL(pageUrl);
        sectionsUrl.searchParams.set('sections', sectionId);
        candidates.push(sectionsUrl.toString());
      }
      candidates.push(pageUrl.toString());

      let lastError = null;
      for (const candidate of candidates) {
        const response = await fetch(candidate, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) {
          lastError = new Error('load more fetch failed');
          continue;
        }
        const parsed = await parseBlogGridFromResponse(response);
        if (!parsed.grid) {
          lastError = new Error('load more markup missing');
          continue;
        }
        if (!blogGridHasNewCards(parsed.grid, existingHrefs)) {
          lastError = new Error('load more returned duplicates');
          continue;
        }
        return parsed;
      }
      throw lastError || new Error('load more markup missing');
    }

    function setBlogLoadMoreLoading(loadMoreEl, isLoading) {
      const btn = loadMoreEl.querySelector('[data-load-more-btn]');
      loadMoreEl.dataset.loading = isLoading ? 'true' : 'false';
      if (!btn) return;
      btn.disabled = isLoading;
      if (isLoading) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    }

    function finishBlogLoadMore(loadMoreEl, nextUrl) {
      if (nextUrl) {
        loadMoreEl.setAttribute('data-next-url', nextUrl);
        setBlogLoadMoreLoading(loadMoreEl, false);
        return;
      }
      loadMoreEl.remove();
    }

    async function loadBlogMore(loadMoreEl) {
      const nextUrl = loadMoreEl.getAttribute('data-next-url');
      if (!nextUrl || loadMoreEl.dataset.loading === 'true') return;

      const grid = loadMoreEl.closest('.blog-grid');
      const main = grid && grid.querySelector('[data-blog-grid-main]');
      if (!grid || !main) return;

      setBlogLoadMoreLoading(loadMoreEl, true);

      try {
        const sectionId = getBlogSectionId(grid);
        const existingHrefs = getBlogCardHrefs(main);
        const parsed = await fetchBlogLoadMoreGrid(nextUrl, sectionId, existingHrefs);
        if (!document.contains(loadMoreEl) || !document.contains(main)) return;

        const newMain = parsed.grid.querySelector('[data-blog-grid-main]');
        const newLoadMore = parsed.grid.querySelector('blog-grid-load-more, .blog-grid__load-more');
        let appended = 0;

        if (newMain) {
          Array.from(newMain.children).forEach((card) => {
            const link = card.querySelector('a[href]');
            const key = link ? link.getAttribute('href') : '';
            if (key && existingHrefs.has(key)) return;
            main.appendChild(card);
            if (key) existingHrefs.add(key);
            appended += 1;
          });
          initBlogCardImages(main);
        }

        const returnedNext = newLoadMore ? newLoadMore.getAttribute('data-next-url') : '';
        const nextIsNew = returnedNext && returnedNext !== nextUrl;

        if (appended === 0) {
          finishBlogLoadMore(loadMoreEl, '');
          return;
        }

        finishBlogLoadMore(loadMoreEl, nextIsNew ? returnedNext : '');
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        window.location.assign(nextUrl);
      } finally {
        if (document.contains(loadMoreEl)) setBlogLoadMoreLoading(loadMoreEl, false);
      }
    }

    async function loadBlogFilter(url, grid, options) {
      const opts = options || {};
      if (!grid) return;
      if (!opts.fromPopstate && isCurrentBlogUrl(url)) return;

      const sectionId = getBlogSectionId(grid);
      if (blogFilterAbort) blogFilterAbort.abort();
      blogFilterAbort = new AbortController();
      const requestId = ++blogFilterRequest;
      const scrollY = window.scrollY || window.pageYOffset || 0;

      grid.setAttribute('aria-busy', 'true');

      try {
        const parsed = await fetchBlogFilterGrid(url, sectionId, blogFilterAbort.signal);
        if (requestId !== blogFilterRequest) return;

        applyBlogFilterMarkup(grid, parsed.grid);
        if (document.activeElement && grid.contains(document.activeElement)) {
          document.activeElement.blur();
        }
        lockBlogScroll(scrollY);
        requestAnimationFrame(() => lockBlogScroll(scrollY));
        initPageSearch(grid);

        if (!opts.fromPopstate) {
          blogFilterUsed = true;
          history.pushState({ blogGridFilter: true }, '', url);
        }

        if (parsed.title) document.title = parsed.title;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        window.location.assign(url);
      } finally {
        if (requestId === blogFilterRequest) {
          grid.removeAttribute('aria-busy');
          lockBlogScroll(scrollY);
        }
      }
    }

    function handleBlogFilterClick(event) {
      const filterBtn = event.target.closest('[data-filter-btn]');
      if (!filterBtn || filterBtn.tagName !== 'A' || !filterBtn.href) return false;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
      const grid = filterBtn.closest('.blog-grid');
      if (!grid) return false;

      event.preventDefault();
      event.stopPropagation();

      const dropdown = filterBtn.closest('[data-space-dropdown]');
      if (dropdown) closeSpaceDropdown(dropdown);
      clearBlogSearch(grid);
      loadBlogFilter(resolveBlogFilterUrl(filterBtn, grid), grid);
      return true;
    }

    if (!window.__blogGridEnhancementsBound) {
      window.__blogGridEnhancementsBound = true;

      document.addEventListener('click', (event) => {
        handleBlogFilterClick(event);
      }, true);

      document.addEventListener('click', (event) => {
        const loadMoreBtn = event.target.closest('[data-load-more-btn]');
        if (loadMoreBtn) {
          const loadMore = loadMoreBtn.closest('blog-grid-load-more, .blog-grid__load-more');
          if (loadMore) {
            event.preventDefault();
            loadBlogMore(loadMore);
          }
          return;
        }

        const searchTrigger = event.target.closest('[data-open-blog-site-search]');
        if (searchTrigger) {
          event.preventDefault();
          openSiteSearch(searchTrigger);
          return;
        }

        const clearBtn = event.target.closest('[data-search-clear]');
        if (clearBtn) {
          const grid = clearBtn.closest('.blog-grid');
          if (grid) clearBlogSearch(grid);
          return;
        }

        const spaceTrigger = event.target.closest('[data-space-trigger]');
        if (spaceTrigger) {
          event.preventDefault();
          toggleSpaceDropdown(spaceTrigger.closest('[data-space-dropdown]'));
          return;
        }

        if (!event.target.closest('[data-space-dropdown]')) {
          document.querySelectorAll('[data-space-dropdown].is-open').forEach(closeSpaceDropdown);
        }
      });

      window.addEventListener('popstate', () => {
        if (!blogFilterUsed) return;
        const grid = document.querySelector('.blog-grid');
        if (!grid) return;
        loadBlogFilter(window.location.href, grid, { fromPopstate: true });
      });

      document.addEventListener('touchstart', (event) => {
        const link = event.target.closest('.blog-grid--showcase .blog-grid__card-link');
        if (link) link.classList.add('is-tapped');
      }, { passive: true });

      window.addEventListener('resize', () => {
        document.querySelectorAll('.blog-grid').forEach(updateSearchWrap);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('[data-space-dropdown].is-open').forEach(closeSpaceDropdown);
      });

      document.addEventListener('shopify:section:load', (event) => {
        initPageSearch(event.target);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initPageSearch();
      });
    } else {
      initPageSearch();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-browse"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function openSiteSearch(trigger) {
        trigger.blur();

        const modal = document.getElementById('search-modal');
        if (modal && typeof modal.showDialog === 'function') {
          modal.showDialog();
          return;
        }

        const headerSearch = document.querySelector('search-button button, .search-action button');
        if (headerSearch) {
          headerSearch.click();
          return;
        }

        const searchUrl = trigger.getAttribute('data-search-url');
        if (searchUrl) window.location.href = searchUrl;
      }

      function applyCollectionSearch(root) {
        const input = root.querySelector('[data-collection-search]');
        if (!input) return;

        const query = input.value.trim().toLowerCase();
        const results = root.querySelector('[data-search-results]');
        const countEl = root.querySelector('[data-search-count]');
        const clearBtn = root.querySelector('[data-search-clear]');
        const noResults = root.querySelector('.collection-browse__no-results');
        const items = results ? results.querySelectorAll('[data-search-item]') : [];

        if (clearBtn) clearBtn.hidden = query.length === 0;

        if (!query) {
          root.classList.remove('is-searching');
          if (results) results.hidden = true;
          if (countEl) countEl.hidden = true;
          if (noResults) noResults.hidden = true;
          items.forEach((item) => {
            item.hidden = false;
          });
          return;
        }

        root.classList.add('is-searching');
        if (results) results.hidden = false;

        let visible = 0;
        items.forEach((item) => {
          const haystack = (item.getAttribute('data-search-text') || '').toLowerCase();
          const match = haystack.includes(query);
          item.hidden = !match;
          if (match) visible += 1;
        });

        if (countEl) {
          countEl.hidden = false;
          countEl.textContent = visible === 1 ? '1 Collection' : visible + ' Collections';
        }

        if (noResults) {
          noResults.hidden = visible > 0;
          const template = noResults.getAttribute('data-message-template') || '';
          noResults.textContent = template.replace('[query]', input.value.trim());
        }

        requestAnimationFrame(() => updateSearchWrap(root));
      }

      function updateSearchWrap(root) {
        const tabs = root.querySelector('.collection-browse__filter-nav-wrap');
        const cluster = root.querySelector('.collection-browse__search-cluster');
        if (!tabs || !cluster) return;
        cluster.classList.remove('is-wrapped');
        const wrapped = cluster.offsetTop > tabs.offsetTop + 2;
        cluster.classList.toggle('is-wrapped', wrapped);
      }

      function closeBrowseDropdown(dropdown) {
        if (!dropdown) return;
        dropdown.classList.remove('is-open');
        const trigger = dropdown.querySelector('[data-browse-trigger]');
        const panel = dropdown.querySelector('.collection-browse__space-panel');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      }

      function toggleBrowseDropdown(dropdown) {
        if (!dropdown) return;
        const isOpen = dropdown.classList.contains('is-open');
        document.querySelectorAll('[data-browse-dropdown].is-open').forEach((openDropdown) => {
          if (openDropdown !== dropdown) closeBrowseDropdown(openDropdown);
        });
        if (isOpen) {
          closeBrowseDropdown(dropdown);
          return;
        }
        dropdown.classList.add('is-open');
        const trigger = dropdown.querySelector('[data-browse-trigger]');
        const panel = dropdown.querySelector('.collection-browse__space-panel');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (panel) panel.hidden = false;
      }

      function applyGroupFilter(browse, groupId) {
        if (!browse) return;
        const selectedId = !groupId || groupId === 'all' ? '' : groupId;
        browse.querySelectorAll('.collection-browse__group').forEach((group) => {
          group.hidden = selectedId !== '' && group.getAttribute('data-group') !== selectedId;
        });

        browse.querySelectorAll('[data-group-option]').forEach((option) => {
          const optionId = option.getAttribute('data-group-option');
          const isActive = selectedId === '' ? optionId === 'all' : optionId === selectedId;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        const trigger = browse.querySelector('[data-browse-trigger]');
        if (trigger) {
          const spaceLabel = trigger.querySelector('.collection-browse__space-trigger-label-space');
          const activeOption = selectedId
            ? browse.querySelector('[data-group-option="' + selectedId + '"]')
            : null;
          const groupLabel = activeOption ? activeOption.getAttribute('data-group-label') || activeOption.textContent.trim() : '';
          trigger.classList.toggle('is-selected', Boolean(selectedId));
          if (spaceLabel) {
            if (selectedId && groupLabel) {
              spaceLabel.textContent = ': ' + groupLabel;
              spaceLabel.hidden = false;
            } else {
              spaceLabel.textContent = '';
              spaceLabel.hidden = true;
            }
          }
        }

        requestAnimationFrame(() => {
          browse.querySelectorAll('[data-sub-links]').forEach(updateSubLinks);
          updateSearchWrap(browse);
        });
      }

      function clearCollectionSearch(root) {
        const input = root.querySelector('[data-collection-search]');
        if (!input || !input.value) return;
        input.value = '';
        applyCollectionSearch(root);
      }

      function updateSubLinks(wrap) {
        const list = wrap.querySelector('.collection-browse__sub-links');
        const button = wrap.querySelector('[data-sub-links-toggle]');
        if (!list || !button) return;

        const expanded = wrap.classList.contains('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? 'VIEW LESS' : 'VIEW MORE';

        if (expanded) {
          button.hidden = false;
          return;
        }

        button.hidden = list.scrollHeight <= list.clientHeight + 1;
      }

      function initSubLinks(root) {
        const wraps = (root || document).querySelectorAll('[data-sub-links]');
        wraps.forEach((wrap) => {
          updateSubLinks(wrap);
          const list = wrap.querySelector('.collection-browse__sub-links');
          if (!list || list.dataset.subLinksObserved) return;
          list.dataset.subLinksObserved = 'true';
          if (typeof ResizeObserver === 'undefined') return;
          const observer = new ResizeObserver(() => updateSubLinks(wrap));
          observer.observe(list);
        });
      }

      function initPageSearch(root) {
        const scope = root || document;
        scope.querySelectorAll('[data-collection-search]').forEach((input) => {
          if (input.dataset.searchBound) return;
          input.dataset.searchBound = 'true';
          const browse = input.closest('collection-browse');
          if (!browse) return;
          input.addEventListener('input', () => applyCollectionSearch(browse));
        });

        scope.querySelectorAll('collection-browse').forEach((browse) => {
          if (browse.dataset.wrapObserved) return;
          browse.dataset.wrapObserved = 'true';
          const toolbar = browse.querySelector('.collection-browse__toolbar');
          updateSearchWrap(browse);
          if (!toolbar || typeof ResizeObserver === 'undefined') return;
          const observer = new ResizeObserver(() => updateSearchWrap(browse));
          observer.observe(toolbar);
        });
      }

      if (!window.__collectionBrowseEnhancementsBound) {
        window.__collectionBrowseEnhancementsBound = true;

        document.addEventListener('click', (event) => {
          const searchTrigger = event.target.closest('[data-open-site-search]');
          if (searchTrigger) {
            event.preventDefault();
            openSiteSearch(searchTrigger);
            return;
          }

          const clearBtn = event.target.closest('[data-search-clear]');
          if (clearBtn) {
            const browse = clearBtn.closest('collection-browse');
            if (browse) clearCollectionSearch(browse);
            return;
          }

          const browseTrigger = event.target.closest('[data-browse-trigger]');
          if (browseTrigger) {
            event.preventDefault();
            toggleBrowseDropdown(browseTrigger.closest('[data-browse-dropdown]'));
            return;
          }

          const groupOption = event.target.closest('[data-group-option]');
          if (groupOption) {
            const browse = groupOption.closest('collection-browse');
            const dropdown = groupOption.closest('[data-browse-dropdown]');
            if (browse) {
              event.preventDefault();
              clearCollectionSearch(browse);
              applyGroupFilter(browse, groupOption.getAttribute('data-group-option'));
            }
            if (dropdown) closeBrowseDropdown(dropdown);
            return;
          }

          const filterBtn = event.target.closest('[data-filter-btn]');
          if (filterBtn) {
            const browse = filterBtn.closest('collection-browse');
            if (browse) clearCollectionSearch(browse);
          }

          if (!event.target.closest('[data-browse-dropdown]')) {
            document.querySelectorAll('[data-browse-dropdown].is-open').forEach(closeBrowseDropdown);
          }

          const moreButton = event.target.closest('[data-sub-links-toggle]');
          if (!moreButton) return;
          const wrap = moreButton.closest('[data-sub-links]');
          if (!wrap) return;
          wrap.classList.toggle('is-expanded');
          updateSubLinks(wrap);
        });

        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          document.querySelectorAll('[data-browse-dropdown].is-open').forEach(closeBrowseDropdown);
        });

        window.addEventListener('resize', () => {
          document.querySelectorAll('[data-sub-links]').forEach(updateSubLinks);
          document.querySelectorAll('collection-browse').forEach(updateSearchWrap);
        });

        document.addEventListener('shopify:section:load', (event) => {
          initSubLinks(event.target);
          initPageSearch(event.target);
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          initSubLinks();
          initPageSearch();
        });
      } else {
        initSubLinks();
        initPageSearch();
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-header"]) return;
  try {
    
    (function () {
      const inits = new WeakSet();

      function initSearchHeader(root) {
        if (!root || inits.has(root)) return;
        inits.add(root);

        const editButton = root.querySelector('[data-search-header-edit]');
        const form = root.querySelector('[data-search-header-form]');
        const input = root.querySelector('[data-search-header-input]');
        if (!editButton || !form || !input) return;

        function openEdit() {
          root.classList.add('search-header__intro--editing');
          form.inert = false;
          form.setAttribute('aria-hidden', 'false');
          editButton.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(function () {
            input.focus();
            input.select();
          });
        }

        function closeEdit() {
          root.classList.remove('search-header__intro--editing');
          form.inert = true;
          form.setAttribute('aria-hidden', 'true');
          editButton.setAttribute('aria-expanded', 'false');
        }

        editButton.addEventListener('click', openEdit);

        form.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeEdit();
            editButton.focus();
          }
        });

        document.addEventListener('pointerdown', function (event) {
          if (!root.classList.contains('search-header__intro--editing')) return;
          if (root.contains(event.target)) return;
          closeEdit();
        });
      }

      document.querySelectorAll('[data-search-header]').forEach(initSearchHeader);

      document.addEventListener('shopify:section:load', function (event) {
        event.target.querySelectorAll('[data-search-header]').forEach(initSearchHeader);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockist-overview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-stockist-gallery]');
    roots.forEach((root) => {
      const scroller = root.querySelector('[data-gallery-scroller]');
      if (!scroller) return;
      const prev = root.querySelector('[data-gallery-prev]');
      const next = root.querySelector('[data-gallery-next]');
      const step = () => Math.max(scroller.clientWidth, 1);
      if (prev) {
        prev.addEventListener('click', () => {
          scroller.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          scroller.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
